import { Component, ChangeDetectorRef, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, take } from 'rxjs/operators';
//import moment from 'moment';
import moment from 'moment/min/moment-with-locales';
//import 'moment/locale/sv'
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScheduleEvent, ScheduleViewModel } from '../../../shared/models/ScheduleModels';
import { ScheduleService } from '../../../shared/services/schedule.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { Globals } from '../../../shared/models/globals';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { SelectGamesDialogComponent } from '../../components/select-games-dialog/select-games-dialog.component';
import { AddEventDialogComponent } from '../../components/add-event-dialog/add-event-dialog.component';
import { GenericEventComponent } from "../../components/generic-event/generic-event.component";
import { GameEventDetailsDialogComponent, GameEventDetailsDialogResult } from '../../../shared/components/game-event-details-dialog/game-event-details-dialog.component';

@Component({
    selector: 'app-schedule-month-small',
    imports: [CommonModule, MaterialModule, TranslateModule, RouterModule, GenericEventComponent],
    templateUrl: './schedule-month-small.component.html',
    styleUrl: './schedule-month-small.component.css'
})
export class ScheduleMonthSmallComponent {

    private route = inject(ActivatedRoute);
    private destroyRef = inject(DestroyRef);
    private cdr = inject(ChangeDetectorRef);

    Days = signal<Array<Date>>([]);
    WeekIndex = signal<Array<number>>([]);
    DayActive = signal<Array<boolean>>([]);
    DayClass = signal<Array<string>>([]);
    daysOfMonth = signal<any[]>([]);
    schedule = signal<ScheduleViewModel | null>(null);
    currentYear = signal<number>(new Date().getFullYear());
    currentMonth = signal<number>(new Date().getMonth());
    currentMonthText = signal<string>("");
    isLoading = signal<boolean>(false);
    currentTz = signal<string>("");
    selectedDate = signal<Date>(new Date());
    selectedDayEventlist = signal<ScheduleEvent[]>([]);

    dialog = inject(MatDialog);

    constructor(private scheduleService: ScheduleService,
        public _router: Router,
        private _globals: Globals,
        private translate: TranslateService,
        private _snackBar: MatSnackBar) {
        moment.locale(this._globals.selectedLocale);

    }

    ngOnInit() {

        this.route.queryParams
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(params => {
                // Access query params here
                const selectedDate = params['selectedDate'];
                // console.log('Query params changed, selectedDate:', selectedDate);

                if (selectedDate) {
                    this.selectedDate.set(new Date(selectedDate));
                    this.getScheduleData();
                } else {
                    this.selectedDate.set(new Date());
                    this.getScheduleData();
                }
            });

        //moment.locale('sv');
        /*  var now = new Date();
         this.currentYear = this.selectedDate().getFullYear();
         this.currentMonth = this.selectedDate().getMonth();
         var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 });//.add(1, 'months');
 
 
         this.currentMonthText = m.format('MMMM');
 
         this.getScheduleData(); */


    }




    getScheduleData() {
        // Prevent multiple simultaneous calls
        if (this.isLoading()) {
            // console.log('Already loading, skipping duplicate call');
            return;
        }
        
        this.isLoading.set(true);
        // console.log('Starting to load schedule data');
        //console.log(this.currentYear() + '-' + (this.currentMonth()+1));
        this.currentYear.set(this.selectedDate().getFullYear());
        this.currentMonth.set(this.selectedDate().getMonth());
        //this.schedule.set(new ScheduleViewModel());
        this.scheduleService.getSchedule(this.currentYear(), this.currentMonth() + 1)
            .pipe(
                take(1),
                // tap(() => console.log('Data received, updating signals')),
                finalize(() => {
                    // console.log('Finalize: setting isLoading to false');
                    this.isLoading.set(false);
                    this.cdr.markForCheck();
                })
            )
            .subscribe({
                next: (data) => {
                    this.schedule.set(data);

                    let a = moment(data.StartDateForMonthView);
                    let b = moment(data.EndDateForMonthView);
                    let tempDate = a;
                    let daysCount = b.diff(a, 'days');
                    this.Days.set([]);
                    this.DayClass.set([]);

                    //console.log('*dayscount' + daysCount);
                    for (let i = 0; i <= daysCount; i++) {

                        this.Days.update(days => [...days, tempDate.toDate()]);

                        var tmpClass = "calendar-day";
                        if (tempDate < moment(data.StartDateForMonth) || tempDate > moment(data.EndDateForMonth)) {
                            //tmpClass += " calendar-day-outofrange ";
                        }
                        if (tempDate.isSame(moment(), 'day')) {
                            //console.log("today found");
                            tmpClass += " calendar-day-today ";
                        }
                        //console.log(tempDate);
                        //console.log(moment().toDate());

                        this.DayClass.update(classes => [...classes, tmpClass]);


                        tempDate = tempDate.add(1, 'day');

                    }

                    this.loadEvents(this.selectedDate(), 0);

                    // console.log('Schedule data loaded successfully');
                    this.cdr.markForCheck();
                    //console.log(this.schedule().EventList);
                },
                error: (error) => {
                    // console.error('Error loading schedule:', error);
                }
            });
        // console.log(this.Days());
    }

    getEvents(day: Date): Array<ScheduleEvent> {
        /* console.log(this.schedule().EventList.filter( event=>{
          return moment(event.EventStart).isSame(moment(day), 'day');
        })); */

        const currentSchedule = this.schedule();
        if (!currentSchedule) return [];
        
        return currentSchedule.EventList.filter(event => {
            return moment(event.EventStartUTC).isSame(moment(day), 'day');
        });
    }

    loadEvents(day: Date, i: number) {
        this.selectedDate.set(day);
        this.selectedDayEventlist.set([]);
        const el = document.getElementById("day_" + i);
        if (el) {
            el.className = " calendar-day calendar-day-selected ";
        }
        // console.log("Selected date: " + day + ":index:" + i);
        for (let j = 0; j < this.Days().length; j++) {
            var dle = document.getElementById("day_" + j);
            if (dle && j != i)
                dle.className = "calendar-day";
            //this.DayClass()[j] = this.DayClass()[j].replace("calendar-day", "").trim();
        }
        this.selectedDayEventlist.set(this.getEvents(day));
        //console.log("Selected day events: ", this.selectedDayEventlist());
        
    }


    openGameDetails(event: ScheduleEvent) {
        const dialogRef = this.dialog.open(GameEventDetailsDialogComponent, {
            maxWidth: '520px',
            width: '92vw',
            panelClass: 'event-details-dialog',
            data: event,
        });

        dialogRef.afterClosed()
            .pipe(take(1))
            .subscribe((result: GameEventDetailsDialogResult | undefined) => {
                if (result?.action === 'delete' && result.eventId) {
                    this.deleteEventFromCalendar(result.eventId);
                } else if (result?.action === 'viewGame' && result.gameId) {
                    this._router.navigate(['/games', result.gameId]);
                }
            });
    }

    addGameEventToCalendar(day: Date) {
        //console.log(day);
        let dialogRef = this.dialog.open(SelectGamesDialogComponent, {
            width: '100vw',
            height: '100dvh',
            maxWidth: '100vw',
            maxHeight: '100dvh',
            panelClass: 'select-games-dialog-panel',
            data: { dateFrom: day, dateTo: day }
        });

        dialogRef.afterClosed()
            .pipe(take(1))
            .subscribe(result => {
                if (result) {
                    //console.log(result);
                    result.forEach((game: any) => {
                        this.scheduleService.addGameToSchedule(game.value, day, "", false)
                            .pipe(take(1))
                            .subscribe(res => {
                                //console.log(res);                        
                                this.getScheduleData();

                            });
                    });

                }
            });
    }


    addGenericEventToCalendar(day: Date) {
        // console.log(day);
        let dialogRef = this.dialog.open(AddEventDialogComponent, {
         /*    width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh', */
             width: '100vw',
            maxWidth: '450px',
            height: '100dvh',
            maxHeight: '100dvh',
            panelClass: 'side-dialog',
            position: {
                right: '0'
            },
            data: { selectedDate: day }
        });

        dialogRef.afterClosed()
            .pipe(take(1))
            .subscribe(result => {
                if (result) {
                    this.getScheduleData();
                    //console.log(result);
                    /*  result.forEach((game: any) => {
                         this.scheduleService.addGameToSchedule(game.value, day, "", false).subscribe(res => {
                             //console.log(res);                        
                             this.getScheduleData();
     
                         });
                     }); */

                }
            });
    }

    deleteEventFromCalendar(EventId: string) {
        //console.log(EventId);    
        this.scheduleService.removeEventFromSchedule(EventId)
            .pipe(take(1))
            .subscribe(res => {
                //console.log(res);
                this.openSnackBar("EVENT REMOVED", "CLOSE");
                this.selectedDayEventlist.set([]);
                this.getScheduleData();        
                this.loadEvents(this.selectedDate(), 0);
            });

    }

/*     nextMonth() {
        var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 }).add(1, 'months');

        //console.log(m.format('MMMM'));
        this.currentYear = m.year();
        this.currentMonth = m.month();
        this.currentMonthText = m.format('MMMM');

        this.getScheduleData();

    }

    previousMonth() {
        var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 }).subtract(1, 'months');
        //console.log(m);
        this.currentYear = m.year();
        this.currentMonth = m.month();
        this.currentMonthText = m.format('MMMM');
        this.getScheduleData();

    } */

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 2000,
        });
    }


}
